/* ==========================================================================
   Zooted Prestige — product.js
   Product page gallery (desktop thumbs + mobile swipe) and variant picker.
   Loaded only on product templates.
   ========================================================================== */
(function () {
  'use strict';

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ------------------------------------------------------------------
     Gallery
     ------------------------------------------------------------------ */
  $$('[data-gallery]').forEach(function (gallery) {
    var track = $('[data-gallery-track]', gallery);
    var thumbs = $$('[data-gallery-thumb]', gallery);
    if (!track) return;

    function goTo(index) {
      var slide = track.children[index];
      if (!slide) return;
      track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      thumbs.forEach(function (t, i) { t.setAttribute('aria-current', i === index ? 'true' : 'false'); });
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { goTo(i); });
    });

    track.addEventListener('scroll', function () {
      clearTimeout(track._t);
      track._t = setTimeout(function () {
        var index = Math.round(track.scrollLeft / track.clientWidth);
        thumbs.forEach(function (t, i) { t.setAttribute('aria-current', i === index ? 'true' : 'false'); });
      }, 90);
    }, { passive: true });
  });

  /* ------------------------------------------------------------------
     Variant picker (accessory products)
     ------------------------------------------------------------------ */
  $$('form[data-product-form]').forEach(function (form) {
    var variantsScript = form.getAttribute('data-variants-id');
    var script = variantsScript ? document.getElementById(variantsScript) : null;
    if (!script) return;
    var variants;
    try { variants = JSON.parse(script.textContent); } catch (err) { return; }

    var idInput = $('input[name="id"]', form);
    var priceEl = document.querySelector('[data-product-price]');
    var submitBtn = $('[type="submit"]', form);

    function selectedOptions() {
      return $$('.variant-fieldset', form).map(function (fs) {
        var checked = $('input:checked', fs);
        return checked ? checked.value : null;
      });
    }

    function formatMoney(cents) {
      var format = (window.zootedSettings || {}).moneyFormat || '${{amount}}';
      return format.replace(/\{\{\s*amount[^}]*\}\}/, (cents / 100).toFixed(2)).replace(/<[^>]+>/g, '');
    }

    function update() {
      var opts = selectedOptions();
      var match = variants.find(function (v) {
        return opts.every(function (val, i) { return val === null || v.options[i] === val; });
      });
      if (!match) {
        if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = match.id;
      if (priceEl) {
        priceEl.innerHTML = match.compare_at_price && match.compare_at_price > match.price
          ? '<s>' + formatMoney(match.compare_at_price) + '</s> <span class="sale">' + formatMoney(match.price) + '</span>'
          : formatMoney(match.price);
      }
      if (submitBtn) {
        submitBtn.disabled = !match.available;
        submitBtn.textContent = match.available ? submitBtn.getAttribute('data-label-add') || 'Add to Cart' : 'Sold Out';
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      history.replaceState(null, '', url.toString());
    }

    form.addEventListener('change', function (e) {
      if (e.target.matches('.variant-pill input')) update();
    });
    update();
  });
})();
